import { Controller } from "@hotwired/stimulus"

// Domain switcher controller for toggling domain selection dropdown
export default class DomainSwitcherController extends Controller {
  static targets = ["dropdown", "trigger", "spinner"]

  declare readonly dropdownTarget: HTMLElement
  declare readonly triggerTarget: HTMLElement
  declare readonly spinnerTarget: HTMLElement
  declare readonly hasDropdownTarget: boolean
  declare readonly hasTriggerTarget: boolean
  declare readonly hasSpinnerTarget: boolean

  connect(): void {
    // Close dropdown when clicking outside
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.boundHandleClickOutside)
  }

  disconnect(): void {
    document.removeEventListener("click", this.boundHandleClickOutside)
  }

  toggle(event: Event): void {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle("hidden")
  }

  handleSubmit(event: Event): void {
    const form = (event.target as HTMLElement).closest('form')
    
    // Add haptic feedback if available for better native feel
    this.element.dispatchEvent(new CustomEvent("bridge--haptic:vibrate", { 
      detail: { type: "light" },
      bubbles: true 
    }))

    if (form && this.isNativeApp()) {
      event.preventDefault()
      const host = form.dataset.domainSwitcherHostParam
      const name = form.dataset.domainSwitcherNameParam
      
      // Dispatch custom event that bridge--environment can listen to
      const switchEvent = new CustomEvent("bridge--environment:switch", { 
        detail: { host, name },
        bubbles: true 
      })
      this.element.dispatchEvent(switchEvent)
      
      // Also close menu
      if (this.hasDropdownTarget) {
        this.dropdownTarget.classList.add("hidden")
      }
      return
    }

    // Close dropdown immediately for web
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.add("hidden")
    }
    
    // Show loading spinner
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden")
    }
  }

  private isNativeApp(): boolean {
    return navigator.userAgent.includes("Pacta-Native") || 
           document.documentElement.hasAttribute("data-turbo-native")
  }

  private handleClickOutside(event: Event): void {
    const target = event.target as Node
    if (!this.element.contains(target)) {
      this.dropdownTarget.classList.add("hidden")
    }
  }

  private boundHandleClickOutside!: (event: Event) => void
}
